import { FC, useMemo } from 'react'
import mclasses from '../../styles/modal.module.css'
import classes from './index.module.css'
import cn from 'classnames'
import Modal from '@common/Modal'
import { crmApi } from '@/api'
import { useAddAlert } from '@/hooks/useAddAlert'
import { IcoRemove } from '@/utils/icons'
import Button from '@UI/New/Button'
import { isError } from '@/helpers/checkQuery'
import { LeadState } from '@/api/types/crm/crm.types'

export type LeadFunnelBulkStateRow = { id: number; name: string }

interface LeadFunnelsBulkChangeStateModalProps {
  items: LeadFunnelBulkStateRow[]
  targetType: Extract<LeadState, 'processed' | 'client'>
  open: boolean
  onClose: () => void
  onSuccess?: () => void
}

const LeadFunnelsBulkChangeStateModal: FC<LeadFunnelsBulkChangeStateModalProps> = ({
  items,
  targetType,
  open,
  onClose,
  onSuccess,
}) => {
  const addAlert = useAddAlert()

  const title = useMemo(() => {
    if (targetType === 'processed') {
      return `Вы уверены что хотите перевести ${
        items.length === 1 ? 'лида' : 'лидов'
      } в обработанные?`
    }
    return `Вы уверены что хотите перевести ${
      items.length === 1 ? 'лида' : 'лидов'
    } в клиенты?`
  }, [items.length, targetType])

  const namesLine = items
    .map((item) => item.name)
    .filter(Boolean)
    .join(', ')

  const handleConfirm = () => {
    if (!items.length) {
      onClose()
      return
    }

    crmApi.leads
      .changeLeadFunnelsState(
        { type: targetType },
        { lead_funnel_ids: items.map((item) => item.id) },
      )
      .then(async (res) => {
        if (isError(res)) throw new Error()
        addAlert({
          title: 'Успешно',
          text: 'Состояние лидов успешно обновлено',
          type: 'success',
        })
        await onSuccess?.()
      })
      .catch(() => {
        addAlert({
          title: 'Ошибка',
          text: 'Не удалось изменить состояние лидов',
          type: 'error',
        })
        onClose()
      })
  }

  return (
    <Modal
      active={open}
      className={mclasses.modalWrapper as any}
      setActive={() => onClose()}
    >
      <div className={mclasses.modalContainer}>
        <div className={mclasses.modalHeader}>
          <div className={mclasses.modalTitleContainer}>
            <span className={mclasses.modalHeaderTitle}>{title}</span>
          </div>
          <div className={mclasses.closeIcon} onClick={() => onClose()}>
            <IcoRemove />
          </div>
        </div>
        <div className={cn(mclasses.formWrapper, classes.formWrapper)}>
          <div>
            <p className={mclasses.label}>{items.length === 1 ? 'Лид' : 'Лиды'}</p>
            <p>{namesLine || '—'}</p>
          </div>
        </div>
        <div className={mclasses.actions}>
          <Button color="gray" onClick={() => onClose()}>
            Отменить
          </Button>
          <Button color="primary" onClick={() => handleConfirm()}>
            Подтвердить
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default LeadFunnelsBulkChangeStateModal
